import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
import { Button } from './ui/Button';
const textReviews = [{
  text: <>
        Increíble. Funciona exactamente como dice. Mi vida sexual{' '}
        <strong className="text-white" data-id="element-220">cambió 180 grados</strong>.
      </>,
  author: 'Roberto M.'
}, {
  text: <>
        En 5 días ya tenía{' '}
        <strong className="text-brand-gold" data-id="element-221">control total</strong>. No puedo
        creer que sea tan efectivo.
      </>,
  author: 'Andrés L.'
}, {
  text: <>
        Probé todo antes de esto. Nada funcionó. Esto sí. Es{' '}
        <strong className="text-white" data-id="element-222">impresionante</strong>.
      </>,
  author: 'Fernando R.'
}];
const whatsappChats = [{
  name: 'Martín',
  time: 'Hoy 14:32',
  msg: <>
        Loco, no te miento... esto funciona
        <br data-id="element-223" />
        Mi novia me preguntó qué me pasó 😂
        <br data-id="element-224" />
        Antes duraba 3 minutos,{' '}
        <strong className="text-white" data-id="element-225">ahora 20+</strong>
        <br data-id="element-226" />
        Es como tener superpoderes
      </>
}, {
  name: 'Diego',
  time: 'Hoy 16:45',
  msg: <>
        Hermano gracias por recomendarme esto
        <br data-id="element-227" />
        Una semana y ya tengo{' '}
        <strong className="text-white" data-id="element-228">control total</strong>
        <br data-id="element-229" />
        Ella no para de decirme lo increíble que es
        <br data-id="element-230" />
        Mejor inversión de mi vida
      </>
}, {
  name: 'Carlos',
  time: 'Ayer 22:18',
  msg: <>
        Esto cambió todo para mí
        <br data-id="element-231" />
        Ahora ella es la que{' '}
        <strong className="text-white" data-id="element-232">no puede más</strong> 🔥
        <br data-id="element-233" />
        Control absoluto, tal como promete
      </>
}];
export function Reviews() {
  return <section className="py-16 px-4 bg-black relative border-y border-gray-900" data-id="element-234">
      <div className="max-w-6xl mx-auto" data-id="element-235">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-236">
          <span className="text-6xl mb-6 block" data-id="element-237">⭐</span>
          <div className="flex justify-center gap-1 mb-4" data-id="element-238">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-8 h-8 fill-brand-gold text-brand-gold" data-id="element-239" />)}
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-2" data-id="element-240">4.9/5</h2>
          <p className="text-gray-400" data-id="element-241">
            Basado en{' '}
            <span className="bg-brand-gold/10 px-1 rounded text-brand-gold" data-id="element-242">
              2,847
            </span>{' '}
            reseñas verificadas
          </p>
        </motion.div>

        {/* Text Reviews */}
        <div className="grid md:grid-cols-3 gap-6 mb-10" data-id="element-243">
          {textReviews.map((review, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-brand-card p-6 rounded-xl border border-gray-800" data-id="element-244">
              <div className="flex gap-1 mb-4" data-id="element-245">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-brand-gold text-brand-gold" data-id="element-246" />)}
              </div>
              <p className="text-gray-300 mb-4" data-id="element-247">"{review.text}"</p>
              <p className="text-white font-bold text-sm" data-id="element-248">- {review.author}</p>
            </motion.div>)}
        </div>

        <div className="max-w-3xl mx-auto" data-id="element-249">
          {/* WhatsApp Chats */}
          <div data-id="element-250">
            <h3 className="text-2xl font-bold mb-8 text-center" data-id="element-251">
              Mensajes Reales
            </h3>
            <div className="space-y-6 bg-[#0b141a] p-6 rounded-2xl border border-gray-800" data-id="element-252">
              {whatsappChats.map((chat, index) => <motion.div key={index} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1
            }} className="flex flex-col" data-id="element-253">
                  <div className="bg-[#005c4b] text-[#e9edef] p-3 rounded-lg rounded-tr-none max-w-[85%] self-end relative shadow-sm" data-id="element-254">
                    <p className="text-sm font-bold text-[#53bdeb] mb-1" data-id="element-255">
                      {chat.name}
                    </p>
                    <p className="text-[15px] leading-snug" data-id="element-256">{chat.msg}</p>
                    <span className="text-[11px] text-white/60 float-right mt-1 ml-2" data-id="element-257">
                      {chat.time}
                    </span>
                  </div>
                </motion.div>)}
            </div>
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-10 text-center" data-id="element-258">
          <Button data-id="element-259">QUIERO EL MÉTODO</Button>
        </motion.div>
      </div>
    </section>;
}